import * as React from 'react';

import ProjectFolder56 from './ProjectFolder56';

export const projectFolder56 = () => <ProjectFolder56 />;

export default {
    title: 'Illustration|ProjectFolder56',
    component: ProjectFolder56,
    parameters: {
        notes: "`import ProjectFolder56 from 'box-ui-elements/es/illustration/ProjectFolder56';`",
    },
};
